import {
  DashDetails,
  User,
  ServiceProvider,
  Notifications,
  Coupons,
  Policy,
  Conditions,
  Subscription,
  Invoices,
  Services,
  Banner,
  ServiceProviderView,
} from "../components";
import ChangePassword from "../components/ChangePassword";

const directory = {
  sidebar: {
    Menu: [
      { title: "Dashboard", code: "/", Component: DashDetails },
      { title: "User", code: "user", Component: User },
      {
        title: "Service Provider",
        code: "service-provider",
        Component: ServiceProvider,
      },
      { title: "Services", code: "services", Component: Services },
      { title: "Banner", code: "banner", Component: Banner },
      {
        title: "Notifications",
        code: "notifications",
        Component: Notifications,
      },
      { title: "Coupans", code: "coupans", Component: Coupons },
    ],
    Business: [
      { title: "Support", code: "support" },
      { title: "Privacy Policy", code: "privacy-policy", Component: Policy },
      {
        title: "Terms & Condition",
        code: "terms-conditions",
        Component: Conditions,
      },
      {
        title: "Subscriptions",
        code: "subscriptions",
        Component: Subscription,
      },
      { title: "Invoice", code: "invoice", Component: Invoices },
      {
        title: "Change Password",
        code: "change-password",
        Component: ChangePassword,
      },
    ],
  },
  env: process.env,
  dynamic: [{ code: "service-provider/:id", Component: ServiceProviderView }],
};
export const { sidebar, env, dynamic } = directory;
export default directory;
